import http from 'api/httpClient';

export interface CustomerDataRow {
  Category: string;
  Total: number;
  Average: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Jan: number;
  Feb: number;
  Mar: number;
}

export interface CustomerData {
  customer_code: string;
  customer_name: string;
  rows: CustomerDataRow[];
}

export interface CustomerDataResponse {
  total: number;
  customers: CustomerData[];
}

export interface CustomerDataRequest extends Record<string, unknown> {
  year: string;
  filters: Record<string, string[]>;
  search?: string;
  sort: {
    by: string;
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchCustomerData(
  params: CustomerDataRequest
): Promise<CustomerDataResponse> {
  return http.post('/api/v1/reports/customers/fetch-data', params);
}


export interface BranchDataRow {
  Category: string;
  Total: number;
  Average: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Jan: number;
  Feb: number;
  Mar: number;
}

export interface BranchData {
  ou_code: string;
  ou_name: string;
  rows: BranchDataRow[];
}

export interface BranchDataResponse {
  total: number;
  branches: BranchData[];
}

export interface BranchDataRequest extends Record<string, unknown> {
  year: string;
  filters: Record<string, string[]>;
  customer_code: string;
  search?: string;
  sort: {
    by: string;
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchBranchData(
  params: BranchDataRequest
): Promise<BranchDataResponse> {
  return http.post('/api/v1/reports/customers/branches/fetch-data', params);
}
